import ReportList from "../components/ReportList";

const ListReportPage = () => {
  return (
    <ReportList />
  );
};

export default ListReportPage;
